import { Email } from './../../../classes/contact/contact.class';
import { ModalController, PopoverController } from '@ionic/angular';
import { EventsToolService } from '@omni/services/events-tool/events-tool.service';
import { debounceTime, first, takeUntil } from 'rxjs/operators';
import {
  AfterContentChecked,
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild
} from '@angular/core';
import { ContactOfflineService, EXCLUDED_CONTACT_GLANCE_CARD_ATTRIBUTES } from '@omni/services/contact/contact.service';
import { DatePipe } from '@angular/common';
import { differenceInCalendarDays } from 'date-fns';
import { DateTimeFormatsService } from '@omni/services/date-time-formats/date-time-formats.service';
import { ComponentViewMode, UIService } from '@omni/services/ui/ui.service';
import { DeviceService } from '@omni/services/device/device.service';
import { NavParams } from '@ionic/angular';
import { AuthenticationService } from '@omni/services/authentication.service';
import { TrackingEventNames, TrackService } from '@omni/services/logging/tracking.service';
import { ChildNavNames, NavigationService, PageName } from '@omni/services/navigation/navigation.service';
import { FooterService, FooterViews } from '@omni/services/footer/footer.service';
import { MeetingDataService } from '../../../data-services/meeting/meeting.data.service';
import { MeetingLocationCaptureService } from '../../../data-services/meeting/meeting-location-capture.service';
import { ActivityDataService } from '../../../data-services/activity/activity.service';
import { ActivityService, ActivitySource } from '@omni/services/activity/activity.service';
import { AppointmentActivity } from '../../../classes/activity/appointment.activity.class';
import { RepServices } from '../../../data-services/rep/rep.services';
import { FeatureActionsMap, IoConfigurationFeatureCodes } from '../../../classes/authentication/user.class';
import { ScientificActivityPlan } from '../../../classes/scientific-activity/scientific-activity.class';
import { TranslateService } from '@ngx-translate/core';
import { NotificationService, ToastStyle } from '@omni/services/notification/notification.service';
import { ContactDataService } from '../../../data-services/contact/contact.data.service';
import { CustomerEventsDataService } from '../../../data-services/customer-event/customer-events.data.service';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { Contact } from '../../../classes/contact/contact.class';
import { DynamicFormsService } from '@omni/services/dynamic-forms/dynamic-forms-service';
import { EventName, EventsService } from '@omni/services/events/events.service';
import { ContactConsentCaptureComponent } from '../contact-consent-capture/contact-consent-capture';
import { ActivityCreationService } from '@omni/services/activity/activity-creation.service';
import { QuickActionStripService } from '@omni/services/activity/quick-action-strip.service';
import { ContactQuickActionsService } from '@omni/services/activity/contact-quick-actions.service';
import { DiskService } from '@omni/services/disk/disk.service';
import { CustomerAssessService } from '@omni/services/customer-assess/customer-assess.service';
import { CustomerAssessment } from '@omni/classes/customer-assessment/customer-assessment.class';
import { AssessmentTemplate, EntityOptions, TemplateType } from '@omni/classes/customer-assessment/assessment-template.class';
import { AccountOfflineService } from '@omni/services/account/account.offline.service';
import { IndDropdownListDetailModel } from '@omni/models/indDropdownListModel';
import { SelectListData } from '@omni/components/popover/popover';
import { IndDropdownListComponent } from '@omni/components/shared/ind-dropdown-list/ind-dropdown-list';
import { Guid } from 'typescript-guid';
import { EventActivity, EventParticipant } from '@omni/classes/events-tool/event.class';
import { AttendeeFormat } from '@omni/enums/event/event.enum';
import { InAppBrowser } from '@awesome-cordova-plugins/in-app-browser/ngx';
import { electronApi } from "@omni/services/electron-api";
import { HopQRCodeModal } from '../hop-qr-code-modal/hop-qr-code-modal';
import { MdmService } from '@omni/services/mdm/mdm.service';
import { ControlDataType, DynamicForm, FormType } from '@omni/classes/dynamic-form/dynamic-form.class';
import { DEFAULT_CONTACT_DISPLAY_FORM } from '@omni/config/dynamic-forms/default-contact/default-contact-create';
import { PersonalizeQuickGlanceViewDataModel } from '@omni/models/personalizeQuickGlanceViewModel';
import { getComponent } from '@omni/services/navigation/component-registry';
import { GlanceCardViewDataModel, oneKeyGlanceViewData } from '@omni/models/glanceCardViewDataModel';
import { DEFAULT_FORM_LANGUAGE_CODE } from '@omni/components/shared/ind-display-form/ind-display-form.constants';
import { SecInfoConfigDataService } from '@omni/data-services/sec-info-config/sec-info-config-data-service';
import { SecondaryInfoEntityName } from '@omni/classes/sec-info-config/sec-info.class';



import { FeatureActionsService } from '@omni/services/feature-actions/feature-actions.service';
import { ConsentService } from '@omni/services/consent/consent.service';
import { LocalizationService } from '@omni/services/localization/localization.service';
import { AdoptionLadderJourneyService } from '@omni/services/adoption-ladder-journey/adoption-ladder-journey.service';
import { RxSalesDataService } from '@omni/services/contact-spotlight/rxsalesdata.service';
import { ContactConsent } from '@omni/classes/consent/contact-consent.class';
import { isEmpty, orderBy, remove } from 'lodash-es';

/** Segments that contact-details.html renders a view for; any other value leaves the page blank. */
const CONTACT_DETAILS_SEGMENTS = ['feed', 'info', 'profile', 'timeline', 'consent', 'capture', 'customer-assess', 'customer-assess-teamview', 'journey'];

/**
 * Generated class for the ContactDetailsComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
// OnPush deferred — reads contactService, repService, uiService, footerService, etc. directly in template
@Component({
  selector: 'contact-details',
  templateUrl: 'contact-details.html',
  styleUrls:['contact-details.scss']
})
export class ContactDetailsComponent implements OnInit, AfterViewInit, AfterContentChecked {

  public compViewMode = ComponentViewMode;
  public isAutoSubjectEnabled: boolean = false;
  public isConsentToolEnabled: boolean = false;
  @Input() selectedSP:ScientificActivityPlan;
  public isCustomerEventsEnabled : boolean = false;
  public isEventToolfeatureAction: boolean = false;
  public hasCustomerAssessFA: boolean = false;
  public aiSummaryEnabled: boolean = false;

  @Input()
  contactListMode:string;
  accessedFrom: string;
  callbackEvent: any;
  @Output() editContactHandler = new EventEmitter();
  @Output() openScientificPlanDetails:EventEmitter<ScientificActivityPlan> = new EventEmitter();
  @ViewChild('contactAssessmentTeamview') contactAssessmentTeamview;
  //@ViewChild(Content, {static:true}) content: Content;
  pageName = PageName;

  @ViewChild(ContactConsentCaptureComponent) ccCapture: ContactConsentCaptureComponent;
  isEventParticipantNoteEnabled = false;
  private isEventPassParticipantAssociationEnabled = false;
  private eventNoteModalHandle: any;

  private unsubscribe$ = new Subject<void>();
  public contactInfo: Contact;
  /** Stable RecordRef for Nova's record-summary surface; recomputed by id+name. */
  private _novaRecordCacheKey: string | null = null;
  private _novaRecordCacheVal: { kind: 'contact'; id: string; label: string } | null = null;
  get novaRecord(): { kind: 'contact'; id: string; label: string } | null {
    const c = this.contactInfo;
    if (!c?.ID) return null;
    const label = (c.fullName || (c as any).fullname || '').trim() || 'Contact';
    const key = `${c.ID}|${label}`;
    if (key === this._novaRecordCacheKey) return this._novaRecordCacheVal;
    this._novaRecordCacheKey = key;
    this._novaRecordCacheVal = { kind: 'contact', id: c.ID, label };
    return this._novaRecordCacheVal;
  }
  hasPhoneCallEnabled: boolean = false;
  public isPopPageBtnEnabled:boolean = false;
  public pageTitleControls = [];
  // Mirrors the title bar's chevron and routes through its handler, so the two cannot disagree.
  public glanceBackButton: { id: string, icon: string } | undefined;
  private glanceCardTools = [];
  private titleBarTools = [];
  public glanceNameAction;
  public okPageTitleControls = [];
  public okGlanceViewData: GlanceCardViewDataModel;
  public okGlanceBackButton: { id: string, icon: string } | undefined;
  public contactRelatedToContact:any[]=[];
  public contactToAccount:any[]=[];
  public contactRelatedFromContact:any[]=[];
  private scrollBehaviorSubject: BehaviorSubject<any> = new BehaviorSubject(null);
  public readonly scrollObservable: Observable<any> = this.scrollBehaviorSubject.asObservable().pipe(debounceTime(100));
  private contactHighLightedFromAffiliatedExplorer: boolean = false;
  public contactAssessmentTemplates: AssessmentTemplate[] = [];
  public assessRawData: CustomerAssessment;
  public customerAssessmentIsLoading: boolean = true;
  private _isDisabledGoToContactsToolBtn: boolean = false;
  public isGoToContactBtnEnabled: boolean = false;
  private ngDestroy$ = new Subject<boolean>();
  private journeyDataReset$ = new Subject<void>();
  //assess teamview
  private isTeamViewEnabled: boolean = false;
  public customerAssessmentTeamviewIsLoading: boolean = true;
  public contactAssessmentTemplatesTeamview: AssessmentTemplate[] = [];
  public showQrCodeBtn: boolean = false;
  public enableEditBtn: boolean = false;
  public buLine: number = 0;
  public isFromChat: boolean = false;
  public isOpenedUnmappedAffiliationData : boolean = false;
  public contactGlanceViewData:GlanceCardViewDataModel;
  /** Activity creates, split out of the glance buttons so the card can group them. */
  public contactQuickActions: any[] = [];
  /** Omitted rather than shown empty when nothing is left to offer (D16). */
  public hasQuickActionOverflow = false;
  public contactDetailsSegment:string;
  public isContactInGlobalSearch: boolean = false;
  public showCallPlanSection = false;
  public hasContactJourney: boolean = false;
  private _fromConsentTool: boolean = false;
  public rawContactSuggestionData: any[] = [];
  public rawContactRxSalesData: any[] = [];
  public rawContactRxSalesDataRealTimeFetched: any[] = [];

  constructor(public contactService: ContactOfflineService,
              private contactDataService: ContactDataService,
              public device:DeviceService,
              public repService: RepServices,
              public uiService:UIService,
              private authenticationOfflineService: AuthenticationService,
              public footerService:FooterService,
              public trackingService: TrackService,
              private navService: NavigationService,
              private meetingService: MeetingDataService,
              private meetingLocationCaptureService: MeetingLocationCaptureService,
              private activityDataService: ActivityDataService,
              public notificationService: NotificationService,
              private activityService: ActivityService,
              public customerEventDataService: CustomerEventsDataService,
              private eventsToolService: EventsToolService,
              private translate:TranslateService,
              public events: EventsService,
              private dynamicFormService: DynamicFormsService,
              private disk: DiskService,
              private customerAssessService: CustomerAssessService,
              private accountService: AccountOfflineService,
              private navParams: NavParams,
              private modalCtrl: ModalController,
              private readonly popoverCtrl: PopoverController,
              private inAppBrowser: InAppBrowser,
              private readonly mdmService: MdmService,
              private readonly activityCreationService: ActivityCreationService,
              private readonly quickActions: ContactQuickActionsService,
              private readonly quickActionStrip: QuickActionStripService,
              private secondaryInfoService: SecInfoConfigDataService,
              private featureActionService: FeatureActionsService,
              private consentService: ConsentService,
              private localizationService: LocalizationService,
              private adoptionLadderJourneyService: AdoptionLadderJourneyService,
              private readonly rxSalesDataService: RxSalesDataService,
              private changeDetectorRef: ChangeDetectorRef,
              private readonly datePipe: DatePipe,
              private readonly dateTimeFormatsService: DateTimeFormatsService,
            ) {
  }

  ngOnInit() {
    // Crossing a breakpoint changes how many tiles fit, so the strip has to be rebuilt.
    this.quickActionStrip.capChanges()
      .pipe(takeUntil(this.ngDestroy$))
      .subscribe(() => this._initGlanceCard(true));
    this._fromConsentTool = this.navParams?.data?.fromConsentTool === true;
    this.buLine = this.authenticationOfflineService.user?.buConfigs?.indskr_businessline;
    this.isFromChat = (this.navParams && this.navParams.data && this.navParams.data.viewData && this.navParams.data.viewData.from == 'openChat') || false;
    this.isOpenedUnmappedAffiliationData = this.dynamicFormService.openedUnmappedData;
    this.getActiveContsent();
    this.enableEditBtn = this.enableEditBtn && this.isFromChat;
    this.hasPhoneCallEnabled = this.authenticationOfflineService.hasFeatureAction(FeatureActionsMap.PHONECALL_ACTIVITY) ? true : false;
    if(this.authenticationOfflineService.hasFeatureAction(FeatureActionsMap.CONSENT_TOOL)){
      this.isConsentToolEnabled = true;
    }
    this.hasCustomerAssessFA = this.authenticationOfflineService.hasFeatureAction(FeatureActionsMap.CUSTOMER_ASSESS);
    this.isTeamViewEnabled = this.authenticationOfflineService.hasFeatureAction(FeatureActionsMap.ASSESSMENTS_TEAM_VIEW);
    this.hasContactJourney = this.authenticationOfflineService.hasFeatureAction(FeatureActionsMap.CONTACT_JOURNEY);
    // AI Summary is a contact-insights section and must not appear in the Consent Tool context
    // (same rule the Omnichannel tab follows via isFromConsentToolDrawer()).
    this.aiSummaryEnabled = this.authenticationOfflineService.hasFeatureAction(FeatureActionsMap.CONTACT_AI_SUMMARY) && !this.isFromConsentToolDrawer();

    if (this.contactService.accessedContactListFrom === PageName.EventDetailsPageComponent) {
      if (this.eventsToolService.selectedEventOnEventsTool) {
        const participant = this.eventsToolService.getEventParticipantByContactId(this.eventsToolService.selectedEventOnEventsTool.participants, this.contactService.contactInformation.ID);
        this.isEventParticipantNoteEnabled = (
          !Array.isArray(this.eventsToolService.selectedEventOnEventsTool.participants)
          || !this.authenticationOfflineService.hasFeatureAction(FeatureActionsMap.EVENT_PARTICIPANT_NOTES)
        )
          ? false
          : participant ? true : false;
        this.isEventPassParticipantAssociationEnabled = (
          !isEmpty(this.eventsToolService.selectedEventOnEventsTool.participants)
          || !this.authenticationOfflineService.hasFeatureAction(FeatureActionsMap.EVENT_PASS_PARTICIPANT_ASSOCIATION))
          ? false : participant ? true : false;
      }

      this.events.observe('selectedEventParticipantChanged')
        .pipe(takeUntil(this.ngDestroy$))
        .subscribe(({selectedContacts, contact}: {selectedContacts: Contact[], contact: Contact}) => {
          if (Array.isArray(selectedContacts)) {
            this.isEventParticipantNoteEnabled = (
              !Array.isArray(selectedContacts)
              || !this.authenticationOfflineService.hasFeatureAction(FeatureActionsMap.EVENT_PARTICIPANT_NOTES)
            )
              ? false
              : selectedContacts.some(c => c.ID === this.contactService.contactInformation.ID) ? true : false;
            this.isEventPassParticipantAssociationEnabled = (
              !Array.isArray(selectedContacts)
              || !this.authenticationOfflineService.hasFeatureAction(FeatureActionsMap.EVENT_PASS_PARTICIPANT_ASSOCIATION)
            )
              ? false
              : selectedContacts.some(c => c.ID === this.contactService.contactInformation.ID) ? true : false;
            this.initPageTitleControls();
            this._initGlanceCard(true);
          }
          // if (this.isEventParticipantNoteEnabled && this.navParams.data.contact.ID == contact.ID && this.eventsToolService.selectedEventOnEventsTool.attendeeFormat === AttendeeFormat.propose) {
          if (this.isEventParticipantNoteEnabled && this.navParams.data.contact.ID == contact.ID) {
            this.openEventParticipantDetailsForm(this.eventsToolService.selectedEventOnEventsTool);
          }
        });
    }

    this.footerService.initButtons(FooterViews.Contacts);

    this.setTabsData();
    
    if(this.authenticationOfflineService.hasFeatureAction(FeatureActionsMap.EVENT_REGISTRATION)){
      this.isCustomerEventsEnabled = true;
    } if (this.authenticationOfflineService.hasFeatureAction(FeatureActionsMap.EVENT_TOOL)) {
      this.isEventToolfeatureAction = true;
    }
    this.contactService.contactInformationObservable.pipe(takeUntil(this.unsubscribe$)).subscribe(async data=> {
      if(data && (!this.contactInfo || (this.contactInfo && this.contactInfo.ID != data.ID) || (data?.raw && this.contactService.isInGlobalSearch && this.contactService.isContactInGlobalSearch(data)))) {
        this.isContactInGlobalSearch = this.contactService.isInGlobalSearch && this.contactService.isContactInGlobalSearch(data);
        if (this.hasContactJourney && !this.isContactInGlobalSearch) {
          await this.initContactJourneyData();
        }
        this.fetchContactProfile(data);       
        await this.contactService.fetchContactsCoverageTeam(this.contactService.contactInformation.ID) 
        await this.contactService.fetchAccountContactAffiliations(this.contactService.contactInformation.ID);
        if (this.contactService.isAffiliationEnabled) {
          // Three independent full-collection PouchDB reads; nothing here reads another's result.
          [this.contactRelatedToContact, this.contactToAccount, this.contactRelatedFromContact] = await Promise.all([
            this.contactService.getContactRelatedToByContactId(data.ID),
            this.contactService.getContactToAccountByContactId(data.ID),
            this.contactService.getContactRelatedFromByContactId(data.ID),
          ]);
        }
        this.initPageTitleControls();
        this._initGlanceCard();
        this.initCustomerAssessData(data);
        this.setTabsData();
        this.contactService.contactUpdated.next(true);
      }
      this.contactInfo = data;
      if (!this.uiService.isPlusButtonCickedFromPatricipantsInEventDetails) return;
      this.uiService.isPlusButtonCickedFromPatricipantsInEventDetails = false;
    });
    this.events.observe("affilition:updated")
      .subscribe(async () => {
        this.contactRelatedToContact = await this.contactService.getContactRelatedToByContactId(this.contactInfo.ID);
        this.contactToAccount = await this.contactService.getContactToAccountByContactId(this.contactInfo.ID);
        this.contactRelatedFromContact = await this.contactService.getContactRelatedFromByContactId(this.contactInfo.ID);
        this.initPageTitleControls();
      });
    if(this.navService.getActiveChildNavViewPageName() === PageName.ScientificActivityDetail ||
       this.navService.getActiveChildNavViewPageName() === PageName.CallPlanCustDetailsComponent ||
      (this.navService.getCurrentMasterPageName() == PageName.ContactPageComponent && this.uiService.activeView == 'ReadOnlyContact' && this.activityService.selectedActivity) ||
      (this.navService.getCurrentMasterPageName() == PageName.GoAppActivitiesPageComponent && this.uiService.activeView == 'ReadOnlyContact' && this.activityService.selectedActivity) ||
      this.navService.getCurrentMasterPageName() === PageName.ContactListROComponent ||
      (this.navService.getCurrentMasterPageName() == PageName.GoAppActivitiesPageComponent && this.uiService.activitiesPagePlanTabSelectedPlan ==='goalsPlansTab') ||
      (this.navService.getCurrentMasterPageName() == PageName.CallPlanComponent && this.uiService.activeView == 'CallPlanDetails') ||
      this.navService.getCurrentMasterPageName() === PageName.ShortCallHomeComponent ||
      this.navService.getActiveChildNavViewPageName() === PageName.AccountDetailsComponent )  {
      this.isPopPageBtnEnabled = true;
      if (this.contactService.isInGlobalSearch || this.accountService.isGlobalSearching) this.isPopPageBtnEnabled = false;
    }
    if ((this.dynamicFormService.isOpenedAffiliatedContactOnContact && this.navService.getActiveChildNavViewPageName() === PageName.ContactDetailsComponent)
      || (this.dynamicFormService.isOpenedAffiliatedContactOnAccount && this.navService.getActiveChildNavViewPageName() === PageName.AccountDetailsComponent)) {
      this.contactService.isEnableGoToContactsTool = true;
      this.isPopPageBtnEnabled = true;
      if (this.contactService.isInGlobalSearch || this.accountService.isGlobalSearching) this.isPopPageBtnEnabled = false;
    }
    this.events.observe('refreshContactDetailPageTitle').pipe(first()).subscribe(() => {
      if ((this.dynamicFormService.isOpenedAffiliatedContactOnContact && this.navService.getActiveChildNavViewPageName() === PageName.ContactDetailsComponent)
      || (this.dynamicFormService.isOpenedAffiliatedContactOnAccount && this.navService.getActiveChildNavViewPageName() === PageName.AccountDetailsComponent)
      || this.contactService.contactPageMode == ComponentViewMode.PREVIEW && this.navService.getActiveChildNavViewPageName() === PageName.ContactDetailsComponent
      ) {
        this.contactService.isEnableGoToContactsTool = true;
        this.isPopPageBtnEnabled = true;
      } else if (this.navService.getCurrentMasterPageName() === PageName.ShortCallHomeComponent) {
        this.contactService.isEnableGoToContactsTool = false;
        this.isPopPageBtnEnabled = true;
      } else if (this.navService.getActiveChildNavViewPageName() === PageName.CallPlanCustDetailsComponent
        || (this.navService.getCurrentMasterPageName() === PageName.CallPlanComponent && this.uiService.activeView === 'CallPlanDetails')
        || (this.navService.getCurrentMasterPageName() === PageName.GoAppActivitiesPageComponent && this.uiService.activitiesPagePlanTabSelectedPlan === 'callPlans')
        || (this.navService.getCurrentMasterPageName() === PageName.ActivitiesDetailsPaneComponent && this.uiService.activitiesPagePlanTabSelectedPlan === 'callPlans')) {
        this.contactService.isEnableGoToContactsTool = false;
        this.isPopPageBtnEnabled = true;
      } else {
        this.contactService.isEnableGoToContactsTool = false;
        this.isPopPageBtnEnabled = false;
      }
      this.initPageTitleControls();
      this._initGlanceCard(true);
    });
    this.events.observe('refreshContactDetailPageTitleOnly').pipe(takeUntil(this.ngDestroy$)).subscribe(() => {
      this.initPageTitleControls();
      this._initGlanceCard(true);
    });
    // Full glance-card refresh: same-id contact-data updates (e.g. MedPro
    // Revalidate) need to rebuild the whole card -- name, address, primary
    // values -- not just the buttons. The 'refreshContactDetailPageTitleOnly'
    // path only replaces the buttons array. Separate event keeps the perf
    // profile of the buttons-only path intact for other publishers
    // (activities-details-pane, customer-assess-teamview).
    this.events.observe('refreshContactDetailGlanceData').pipe(takeUntil(this.ngDestroy$)).subscribe(() => {
      this.initPageTitleControls();
      this._initGlanceCard();
    });
    this.events.observe("closeMultiAssessPage").pipe(takeUntil(this.ngDestroy$)).subscribe((data:Contact) => {
      if(data) this.initCustomerAssessData(data);
    });
    this.initPageTitleControls();
    this.initOKPageTitleControls();
    this._initGlanceCard(true);
    this.device.isOfflineObservable.pipe(takeUntil(this.ngDestroy$)).subscribe(isOffline => {
      // if the device offlice diisable
      this.initPageTitleControls();
      this._initGlanceCard(true);
    });
    this.events.observe(EventName.CONTACTDETAILSSEGMENTUPDATE)
      .pipe(takeUntil(this.ngDestroy$))
      .subscribe(() => this.setContactDetailsSegment());

    this.events.observe(EventName.QUICKGLANCECCONTACTREATEPHONECALL)
      .pipe(takeUntil(this.ngDestroy$))
      .subscribe((flag) => {
        this.quickActions.createPhoneCall();
      });

    // Deliberately not awaited: the strip renders in declaration order and corrects itself
    // once the read returns, rather than holding the card behind a disk hit.
    this.quickActionStrip.loadPins('contact')
      .then(() => this._refreshQuickActions())
      .catch(error => console.error('Contact details: could not read pinned quick actions', error));

    // The omnichannel card publishes its tap so the channel picker has something to anchor to.
    this.events.observe(EventName.QUICKGLANCECCONTACTREATEMESSAGE)
      .pipe(takeUntil(this.ngDestroy$))
      .subscribe((tap) => {
        this.quickActions.createMessage(false, tap instanceof Event ? tap : undefined);
      });

    this.events.observe(EventName.QUICKGLANCECCONTACTREATEMESSAGEFIRSTTIME)
    .pipe(takeUntil(this.ngDestroy$))
    .subscribe((flag) => {
      this.quickActions.createMessage(true);
    });

    this.events.observe(EventName.QUICKGLANCECCONTACTREATEMEETING)
      .pipe(takeUntil(this.ngDestroy$))
      .subscribe((tap) => {
        this.quickActions.createMeeting(tap instanceof Event ? tap : undefined);
      });

      this.consentService.allActiveConsentSubject.pipe(takeUntil(this.ngDestroy$)).subscribe((consents: ContactConsent[]) => {
        if (consents && !isEmpty(consents)) {
          this._initGlanceCard();
        }
      })
  }

  ngOnChanges(changes: SimpleChanges) {
    try {
      if (changes) {
        
      }
    }
    catch (err) {
      console.error(err);
    }
  }

  async getActiveContsent(){
    if (!this.device.isOffline) {
      const consent = this.enableEditBtn = await this.meetingService.getActiveGeneralConsent(this.contactService.contactInformation.ID);
      this.showQrCodeBtn = !consent;
      this.initPageTitleControls();
      // Consent arrives after the card is built, and it is what decides the QR button.
      this._initGlanceCard(true);
    }
  }

  private initCustomerAssessData(data: Contact) {
    if (this.hasCustomerAssessFA) {
      if (!this.contactService.getContactByID(data.ID)) {
        this.customerAssessmentIsLoading = false;
        this.customerAssessmentTeamviewIsLoading = false;
      } else {
        this.contactAssessmentTemplates = this.customerAssessService.getTemplatesForEntity(TemplateType.ASSESSMENT, EntityOptions.CONTACT);
        if(this.isTeamViewEnabled) this.contactAssessmentTemplatesTeamview = this.customerAssessService.getTemplatesTeamviewForEntity(TemplateType.ASSESSMENT, EntityOptions.CONTACT);
        this.fetchAssessRawData(data);
        // if(!this.device.isOffline) {
        //   this.fetchAssessRawData(data);
        // }else {
        //   this.fetchOfflineAssessRawData(data);
        // }
      }
    }
  }

  private async fetchAssessRawData(data: Contact) {
    if (this.contactAssessmentTemplates.length == 1) {
      const isProcedureSectionEnabled: boolean = this.contactAssessmentTemplates[0].indskr_metadata.Sections.some(section => section.Procedure) && data.primarySpecialty?.id != null;
      const procedures = isProcedureSectionEnabled ? this.customerAssessService.specialtyProceduresMap.get(data.primarySpecialty.id) : [];
      this.customerAssessService.fetchContactAssessment(data.ID, this.contactAssessmentTemplates[0].indskr_assessmenttemplateid).then((data: CustomerAssessment) => {
        if (isProcedureSectionEnabled && data?.responses) {
          if (isEmpty(procedures)) {
            data.responses = data.responses.filter(resp => resp['indskr_procedures'] == null);
          } else {
            const procedureIds = procedures.map(procedure => procedure.ID);
            data.responses = data.responses.filter(resp => resp['indskr_procedures'] == null || procedureIds.includes(resp['indskr_procedures']))
          }
        }
        this.assessRawData = data;
        this.customerAssessmentIsLoading = false;
        this.customerAssessmentTeamviewIsLoading = false;
      });
    } else {
      this.customerAssessmentIsLoading = false;
      this.customerAssessmentTeamviewIsLoading = false;
    }
  }

  // private async fetchOfflineAssessRawData(data: Contact) {
  //   if(this.contactAssessmentTemplates.length == 1) {
  //     const isProcedureSectionEnabled: boolean = this.contactAssessmentTemplates[0].indskr_metadata.Sections.some(section => section.Procedure) && data.primarySpecialty?.id != null;
  //     const procedures = isProcedureSectionEnabled ? this.customerAssessService.specialtyProceduresMap.get(data.primarySpecialty.id) : [];
  //     this.customerAssessService.fetchOfflineContactAssessment(data.ID).then((data: CustomerAssessment) => {
  //       if (isProcedureSectionEnabled && data?.responses) {
  //         if (isEmpty(procedures)) {
  //           data.responses = data.responses.filter(resp => resp['indskr_procedures'] == null);
  //         } else {
  //           const procedureIds = procedures.map(procedure => procedure.ID);
  //           data.responses = data.responses.filter(resp => resp['indskr_procedures'] == null || procedureIds.includes(resp['indskr_procedures']))
  //         }
  //       }
  //       this.assessRawData = data;
  //       this.customerAssessmentIsLoading = false;
  //       this.customerAssessmentTeamviewIsLoading = false;
  //     });
  //   }else {
  //     this.customerAssessmentIsLoading = false;
  //     this.customerAssessmentTeamviewIsLoading = false;
  //   }
  // }

  public savedCustomerAssessment(data: CustomerAssessment) {
    this.assessRawData = data;
    this.initPageTitleControls();
  }

  ngOnDestroy() {
    if (this.accountService.accountPageMode === ComponentViewMode.PREVIEW) this.accountService.accountPageMode = ComponentViewMode.LISTVIEW;
    this.dynamicFormService.isOpenedAffiliatedContactOnAccount = false;
    this.dynamicFormService.isOpenedAffiliatedAccountOnAccount = false;
    this.dynamicFormService.isOpenedAffiliatedAccountOnContact = false;
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
    this.ngDestroy$.next(true);
    this.ngDestroy$.complete();
  }

  private fetchContactProfile(data) {
    if (this.contactService.isInGlobalSearch || this.accountService.isGlobalSearching) {
      this.contactService.isContactProfileLoaded = true;
      return;
    }
    this.contactDataService.getContactProfile(this.contactService.contactInformation)
      .then(() => {
        this.contactService.isContactProfileLoaded = true;
        this.events.publish('updateProfileData')
      })
      .catch(() => {
        // Even in case of error, show offline only data
        this.contactService.isContactProfileLoaded = true;
    });
  }


  // ionViewDidEnter(){
  //   this.footerService.initButtons(FooterViews.Contacts);
  // }
  ngAfterViewInit(){
    //this.contactSegment = this.uiService.contactDetailsSegment ||'info';
   // this.content.resize();
  }

  ngAfterContentChecked() {
    if(this.authenticationOfflineService.hasFeatureAction(FeatureActionsMap.MEETING_AUTO_SUBJECT)){
      this.isAutoSubjectEnabled = true;
    }
  }

  async segmentChanged(selectedTab: string) {
    if (this.hasCustomerAssessFA) {
      if (this.uiService.contactDetailsSegment == "customer-assess" && this.customerAssessService.isAssessmentDirty && !(await this.customerAssessService.discardChagesForAssess())) {
        return;
      }
    }
    this.contactDetailsSegment = this.uiService.contactDetailsSegment = selectedTab;
    if (selectedTab === 'profile') {
      const insightsEventName = this.contactService.contactPageMode === ComponentViewMode.ADDNEW ? 'Contact Profile via Meeting' : 'ContactProfile'
      this.trackingService.tracking(insightsEventName, TrackingEventNames.CONTACTS)
      this.contactService.isContactProfileLoaded = false;
    } else if (selectedTab === 'timeline') {
      const insightsEventName = this.contactService.contactPageMode === ComponentViewMode.ADDNEW ? 'Contact Timeline  via Meeting' : 'ContactTimeline'
      this.trackingService.tracking(insightsEventName, TrackingEventNames.CONTACTS);
      this.footerService.initButtons(FooterViews.Contacts);
    } else if (selectedTab === 'capture') {
      this.footerService.initButtons(FooterViews.ConsentCapture);
    } else if (selectedTab === 'journey') {
      this.contactInfo = this.contactService.contactInformation;
      this.footerService.initButtons(FooterViews.None);
    } else {
      this.footerService.initButtons(FooterViews.Contacts);
    }
    this.initPageTitleControls();
  }

  async closepage(){
    if(this.customerAssessService.isAssessmentDirty && !(await this.customerAssessService.discardChagesForAssess())) return;
    if(this.navService.getCurrentMasterPageName() == PageName.CallPlanComponent){
      // this.callPlanService.callPlanPageView = "CallPlanCustomerDetail";
      this.uiService.activeView = 'CallPlanDetails';
      this.navService.popChildNavPageWithPageTracking();
    } else if((this.navService.getCurrentMasterPageName() == PageName.GoAppActivitiesPageComponent || this.navService.getCurrentMasterPageName() == PageName.ActivitiesDetailsPaneComponent) && this.uiService.activitiesPageTab == 'plans') {
      this.uiService.activeView = 'ActivitiesPageRightPaneNav';
      this.uiService.showNewActivity = false;
      this.uiService.showRightPane = true;
      this.navService.popChildNavPageWithPageTracking();
    } else if (this.navService.getCurrentPageName() == PageName.ContactPageComponent && this.navService.getPreviousPageName() == PageName.ConsentDetailsComponent) {
      this.contactService.isConsentInvoked = false;
      this.uiService.isConsentFromToolDrawer = false;
      this.footerService.initButtons(FooterViews.ConsentDetails);
      this.uiService.activeView = this.uiService.prevView;
      await this.navService.popWithPageTracking();
      if(this.uiService.consentFlipButton) {
        this.uiService.isEmailAccessedFromConsnentDetails = true;
      }
      return;
    } else {
      this.navService.setChildNavRoot(PageName.NothingSelectedView, PageName.NothingSelectedView, PageName.ContactPageComponent);
      this.navService.setChildNavRightPaneView(false)
    }
    this.contactService.contactInformation = undefined;
  }

  poppage(){
    this.isPopPageBtnEnabled = false;
    if(this.navService.getActiveChildNavName() === 'scientificactivityrightpane'){
      this.navService.popToRootChildNavPageWithPageTracking();
      this.contactService.contactInformation = undefined;
    } else if((this.navService.getCurrentMasterPageName() == PageName.GoAppActivitiesPageComponent || this.navService.getCurrentMasterPageName() == PageName.ActivitiesDetailsPaneComponent) && this.uiService.activitiesPageTab == 'plans') {
      this.uiService.activeView = 'ActivitiesPageRightPaneNav';
      this.uiService.showNewActivity = false;
      this.uiService.showRightPane = true;
      this.contactService.contactInformation = undefined;
      this.navService.popChildNavPageWithPageTracking();
    } else if(this.navService.getCurrentMasterPageName() == PageName.ContactPageComponent) {
      if (this.contactService.contactPageMode == ComponentViewMode.PREVIEW || this.dynamicFormService.isOpenedAffiliatedContactOnContact) {
        if (this.contactService.prevSelected) this.contactService.contactInformation = this.contactService.prevSelected;
        // this.events.publish('highlightContact', this.contactService.contactInformation);
        if (this.contactService.contactPrevPageMode == ComponentViewMode.ADDNEW || this.contactService.contactPrevPageMode == ComponentViewMode.SELECTION) {
          this.contactService.contactPageMode = this.contactService.contactPrevPageMode;
        } else {
          this.contactService.contactPageMode = ComponentViewMode.LISTVIEW;
        }
        this.dynamicFormService.isOpenedAffiliatedContactOnContact = false;
        this._isDisabledGoToContactsToolBtn = false;
        this.dynamicFormService.openedUnmappedData = false;
        this.navService.popChildNavPageWithPageTracking();
        this.events.publish('refreshDisplayForm');
      } else {
        this.uiService.showRightPane = false;
        this.contactService.contactInformation = undefined;
      }
    } else if(this.navService.getCurrentMasterPageName() == PageName.CustomerCallPlanPage){
      this.uiService.activeView = 'CustomerCallPlanDetails';
      this.navService.popChildNavPageWithPageTracking();
    } else if(this.navService.getCurrentMasterPageName() == PageName.CallPlanComponent){
      this.uiService.activeView = 'CallPlanDetails';
      this.navService.popChildNavPageWithPageTracking();
    } else if(this.navService.getCurrentMasterPageName() == PageName.AccountPageComponent){
      if (this.dynamicFormService.isOpenedAffiliatedContactOnAccount) {
        if (this.contactService.contactPrevPageMode === ComponentViewMode.ADDNEW || this.contactService.contactPrevPageMode === ComponentViewMode.SELECTION) {
          this.contactService.contactPageMode = this.contactService.contactPrevPageMode;
        } else {
          this.contactService.contactPageMode = ComponentViewMode.LISTVIEW;
        }
        this.dynamicFormService.isOpenedAffiliatedContactOnAccount = false;
        this._isDisabledGoToContactsToolBtn = false;
        this.dynamicFormService.openedUnmappedData = false;
        this.events.publish('refreshDisplayForm');
        this.navService.setChildNavRightPaneView(false);
        this.navService.popChildNavPageWithPageTracking();
      } else if (this.dynamicFormService.isOpenedAffiliatedContactOnContact) {
        if (this.contactService.prevSelected) this.contactService.contactInformation = this.contactService.prevSelected;
        this.events.publish('highlightContact', this.contactService.contactInformation);
        if (this.contactService.contactPrevPageMode === ComponentViewMode.ADDNEW || this.contactService.contactPrevPageMode === ComponentViewMode.SELECTION) {
          this.contactService.contactPageMode = this.contactService.contactPrevPageMode;
        } else {
          this.contactService.contactPageMode = ComponentViewMode.LISTVIEW;
        }
        this.dynamicFormService.isOpenedAffiliatedContactOnContact = false;
        this._isDisabledGoToContactsToolBtn = false;
        this.dynamicFormService.openedUnmappedData = false;
        this.events.publish('refreshDisplayForm');
      } else {
        this.navService.popChildNavPageWithPageTracking();
      }
    } else if (this.dynamicFormService.isOpenedAffiliatedContactOnAccount) {
      if (this.contactService.contactPrevPageMode === ComponentViewMode.ADDNEW || this.contactService.contactPrevPageMode === ComponentViewMode.SELECTION) {
        this.contactService.contactPageMode = this.contactService.contactPrevPageMode;
      } else {
        this.contactService.contactPageMode = ComponentViewMode.LISTVIEW;
      }
      this.dynamicFormService.isOpenedAffiliatedContactOnAccount = false;
      this._isDisabledGoToContactsToolBtn = false;
      this.dynamicFormService.openedUnmappedData = false;
      this.events.publish('refreshDisplayForm');
      this.navService.popChildNavPageWithPageTracking();
    } else if (this.navService.getCurrentMasterPageName() === PageName.ShortCallHomeComponent) {
      this.uiService.contactDetailsSegment = undefined
      this.contactService.contactInformation = undefined;
      this.contactService.contactPageMode = undefined;
      this.navService.popWithPageTracking();
    } else{
      this.navService.popWithPageTracking();
    }
  }

  handlePlusButton(){
    this.activityService.activitySource = ActivitySource.CONTACT_INFO;
    this.trackingService.tracking('ContactNewActivity', TrackingEventNames.ACTIVITY)
    if(this.authenticationOfflineService.hasFeatureAction(FeatureActionsMap.ALLOCATION_TOOL)
    || this.authenticationOfflineService.hasFeatureAction(FeatureActionsMap.FOLLOW_UP_ACTION_ACTIVITY)
    || this.authenticationOfflineService.hasFeatureAction(FeatureActionsMap.SCIENTIFIC_FOLLOW_UP_TASK)
    || this.authenticationOfflineService.hasFeatureAction(FeatureActionsMap.CASE_INTAKE)
    || this.authenticationOfflineService.hasFeatureAction(FeatureActionsMap.MESSAGE_ACTIVITY)
    || this.authenticationOfflineService.hasFeatureAction(FeatureActionsMap.PROCEDURE_LOG)
    ){
      // sets the default selected activity to meeting
      this.uiService.activeViewNewMeeting = 'meeting';
      if(this.navService.getActiveChildNavName() === "scientificactivityrightpane" || this.navService.getActiveChildNavName() === ChildNavNames.ActivitiesPageNavigation && this.uiService.activitiesPageTab === 'plans' ){
        this.navService.pushChildNavPageWithPageTracking(PageName.NewActivityComponent, PageName.NewActivityComponent, PageName.ScientificActivityPage,
                                                        { from: 'ScientificActivityPage', plan: this.selectedSP, contact: this.contactService.contactInformation})
      } else {
        this.navService.pushChildNavPageWithPageTracking(PageName.NewActivityComponent, PageName.NewActivityComponent, PageName.ContactPageComponent,
          { from: 'ContactPageComponent', contact: this.contactService.contactInformation});
      }
    }
    else{
      this.addNewActivity()
    }
  }

  async handleNavigationForBaseURL() {
    let url:string = this.contactService.baseURLforContactsTool;
    url = url.replace('{{contact.guid}}', this.contactInfo.ID);

    if (this.device.isNativeApp && !this.device.deviceFlags.electron) {
      if (this.device.deviceFlags.ios) {
        const browserRef = this.inAppBrowser.create(url, '_blank', { location: 'no', hideurlbar: 'yes', zoom: 'no' });
      }
      else {
        const browserRef = this.inAppBrowser.create(url, '_system', { location: 'yes', toolbar: 'yes', zoom: 'no' });
      }
    } else {
      if(this.device.deviceFlags.electron) {
        electronApi.openExternal(url);
      }else {
        window.open(url, "_system");
      }
    }
  }

  async handleAffiliationExplorer() {
    this.navService.pushChildNavPageWithPageTracking(PageName.AffiliationExplorerComponent, PageName.AffiliationExplorerComponent, PageName.ContactPageComponent,
      {
        from: 'ContactPageComponent', parent: this.contactService.contactInformation,
        relatedTo: this.contactRelatedToContact, contactAccountAffiliation: this.contactToAccount,
        relatedFrom: this.contactRelatedFromContact
      });
   }

  async addNewActivity() {
    event.stopPropagation();
    const contact = this.contactService.getContactByID(this.contactService.contactInformation['ID']);
    if (!contact) {
      this.notificationService.notify(this.translate.instant('ERROR_FINDING_CONTACT_TO_ADD_TO_MEETING'), 'Contact Details');
      return;
    }
    this.contactService.addToRecentContacts(contact);

    const result = await this.activityCreationService.create('meeting', {
      context: { contact, host: PageName.ContactPageComponent },
    });

    // The app's only live GPS capture, kept at the call site so unifying the create did not
    // quietly extend it to every other meeting.
    if (result.activity) {
      await this.meetingLocationCaptureService.captureContactLocationDistance(result.activity as AppointmentActivity);
    }
  }
  isSplitView(){
    return (window.innerWidth > 500);
  }

  onEditContact(){
    this.editContactHandler.emit();
  }

  onOpenScientificPlanDetails(plan){
    this.openScientificPlanDetails.emit(plan);
  }

  setTabsData() {
    const isGlobalSearch = this.navParams?.data?.link === 'globalSearch' && 
                          this.contactService.isContactInGlobalSearch(this.contactService.contactInformation);
    this.isContactInGlobalSearch = this.contactService.isInGlobalSearch && this.contactService.isContactInGlobalSearch(this.contactService.contactInformation);
    this.showCallPlanSection = this.shouldShowCallPlanSection();
    if (this.authenticationOfflineService.hasFeatureAction(FeatureActionsMap.CUSTOMER360UI, true)) {
      this.setCustomer360UITabsData(isGlobalSearch);
    } else {
      this.setLegacyTabsData(isGlobalSearch);
    }
    
    this.setContactDetailsSegment();
  }

  private setCustomer360UITabsData(isGlobalSearch: boolean) {
    this.uiService.tabsData = [
      {
        displayText: this.translate.instant('FEED'),
        value: "feed",
                disable: this.contactService.isOneKeySearching || this.isFromTerritoryManagement()
      },
      {
        displayText: this.translate.instant('OMNICHANNEL'),
        value: "profile",
        hide: !this.shouldShowOmnichannelTab(),
                disable: this.contactService.isOneKeySearching || this.isFromTerritoryManagement()
      },
      {
        displayText: this.translate.instant('ASSESS'),
        value: "customer-assess",
        hide: !this.hasCustomerAssessFA || !this.shouldShowOmnichannelTab() || this.isFromOpenChat(),
        disable: false
      },
      {
        displayText: this.translate.instant('CONSENTS'),
        value: "consent",
        hide: !this.isConsentToolEnabled || !this.isFromConsentToolDrawer() || this.contactService.isOneKeySearching || this.isFromOpenChat(),
        disable: this.contactService.isOneKeySearching
      },
      {
        displayText: this.translate.instant('CAPTURE'),
        value: "capture",
        hide: !this.isConsentToolEnabled || !this.isFromConsentToolDrawer() || this.contactService.isOneKeySearching || this.isFromOpenChat()
      },
      {
        displayText: this.translate.instant('INFORMATION'),
        value: "info"
      },
      {
        displayText: this.translate.instant('JOURNEY'),
        value: "journey",
        hide: !this.hasContactJourney || this.isContactInGlobalSearch || this.isFromConsentToolDrawer() || this.contactService.isOneKeySearching || this.isFromOpenChat(),
        disable: false
      },
    ];
    this.contactDetailsSegment = this.isFromChat || isGlobalSearch ? 'info' : 'feed';
  }

  private setLegacyTabsData(isGlobalSearch: boolean) {
    this.uiService.tabsData = [
      {
        displayText: this.translate.currentLang !== "es" ? this.translate.instant('INFO') : this.translate.instant('INFORMATION'),
        value: "info"
      },
      {
        displayText: this.translate.instant('ASSESS'),
        value: "customer-assess",
        hide: !this.hasCustomerAssessFA || !this.shouldShowOmnichannelTab() || this.isFromOpenChat(),
        disable: false
      },
      {
        displayText: this.translate.instant('PROFILE'),
        value: "profile",
        hide: !this.shouldShowOmnichannelTab(),
                disable: this.contactService.isOneKeySearching || this.isFromTerritoryManagement()
      },
      {
        displayText: this.translate.instant('CONSENTS'),
        value: "consent",
        hide: !this.isConsentToolEnabled || !this.isFromConsentToolDrawer() || this.contactService.isOneKeySearching || this.isFromOpenChat(),
        disable: this.contactService.isOneKeySearching
      },
      {
        displayText: this.translate.instant('CAPTURE'),
        value: "capture",
        hide: !this.isConsentToolEnabled || !this.isFromConsentToolDrawer() || this.contactService.isOneKeySearching || this.isFromOpenChat()
      },
      {
        displayText: this.translate.instant('TIMELINE'),
        value: "timeline",
        disable: this.contactService.isOneKeySearching || this.isFromTerritoryManagement()
      },
      {
        displayText: this.translate.instant('JOURNEY'),
        value: "journey",
        hide: !this.hasContactJourney || this.isFromConsentToolDrawer() || this.contactService.isOneKeySearching || this.isFromOpenChat(),
        disable: false
      },
    ];
    this.contactDetailsSegment = 'info';
  }

  /**
   * Selects the shared segment when the page renders a view for it; otherwise selects the consent tab
   * when opened from the consent tool, else keeps the current segment, and writes the choice back to
   * the shared segment.
   */
  private setContactDetailsSegment() {
    if (CONTACT_DETAILS_SEGMENTS.includes(this.uiService.contactDetailsSegment)) {
      this.contactDetailsSegment = this.uiService.contactDetailsSegment;
    } else if (this._fromConsentTool) {
      this.contactDetailsSegment = this.uiService.contactDetailsSegment = 'consent';
    } else if (this.isFromChat || this.isContactInGlobalSearch) {
      // Chat/global-search previews require the 'info' segment computed above
      // (setCustomer360UITabsData/setLegacyTabsData) — the configured default
      // must not override these preview contexts.
      this.uiService.contactDetailsSegment = this.contactDetailsSegment;
    } else {
      // OMNI-60504: on a genuine normal open (nothing else forced a segment),
      // let BU_CONTACT_GA_DEFAULTTAB pick the landing tab if configured and the
      // named tab actually exists/is visible for this session; otherwise keep
      // today's default ('feed'/'info' from setCustomer360UITabsData/setLegacyTabsData).
      this.contactDetailsSegment = this.uiService.contactDetailsSegment = this._resolveConfiguredDefaultTab() ?? this.contactDetailsSegment;
    }
  }

  private _resolveConfiguredDefaultTab(): string | null {
    const configuredTab = this.authenticationOfflineService.getIOConfigurationValue(IoConfigurationFeatureCodes.BU_CONTACT_GA_DEFAULTTAB);
    if (!configuredTab) return null;
    const tab = this.uiService.tabsData?.find(t => t.value === configuredTab.toLowerCase() && !t.hide && !t.disable);
    return tab ? tab.value : null;
  }

  private shouldShowOmnichannelTab(): boolean {
    return !this.isFromConsentToolDrawer();
  }

  private shouldShowCallPlanSection(): boolean {
    return this.authenticationOfflineService.hasFeatureAction(FeatureActionsMap.CALL_PLANS)
      && this.authenticationOfflineService.hasFeatureAction(FeatureActionsMap.CUSTOMER360UI, true)
      && this.navService.getCurrentMasterPageName() === PageName.ContactPageComponent
      && this.contactService.contactPageMode === ComponentViewMode.LISTVIEW
      && !this.isFromConsentToolDrawer() && !this.isFromOpenChat()
      && !this.contactService.isOneKeySearching && !this.isContactInGlobalSearch;
  }

  private isFromTerritoryManagement(): boolean {
    return this.navParams?.data?.from === PageName.TerritoryManagementDetailsComponent;
  }

  private isFromConsentToolDrawer(): boolean {
    return this._fromConsentTool ||
           (this.uiService.isConsentFromToolDrawer &&
            this.contactService.accessedContactListFrom === this.pageName.ToolsDrawer);
  }

  ionViewWillEnter() {
    if (this.uiService.contactDetailsShouldRefreshConsentUI) {
      this.uiService.contactDetailsShouldRefreshConsentUI = false;
      this.setTabsData();
      this._initGlanceCard(true);
      this.initPageTitleControls();
    }

    this.changeDetectorRef.markForCheck();
  }

  private isFromOpenChat(): boolean {
    return this.navParams.data?.viewData?.from === 'openChat';
  }

  private initPageTitleControls(): void {
    let buttons = this.buildInitialButtons();
    buttons = this.applySpecialConditions(buttons);
    this.pageTitleControls = buttons;
    this.glanceBackButton = buttons.find(button => button.align === 'left');
    this.glanceNameAction = buttons.find(button => button.id === 'goToContactsTool');
    this.titleBarTools = buttons.filter(button => button.align === 'right' && button.id !== 'pluse-icon' && button !== this.glanceNameAction);
    if (this.contactGlanceViewData) {
      this.contactGlanceViewData = { ...this.contactGlanceViewData, buttons: [...this.glanceCardTools, ...this.titleBarTools] };
    }
  }

  private buildInitialButtons(): any[] {
    let buttons = [];
    
    // Chat close button
    if (this.isFromChat) {
      buttons.push(this.createCloseButton());
    }
    
    // Regular close button
    if (this.shouldShowCloseButton()) {
      buttons.push(this.createCloseButton());
    }
    
    if (this.uiService.contactDetailsSegment === 'customer-assess') {
      return buttons;
    }
    // Customer additional info button (non-assessment, non-listview)
    if (this.shouldShowCustomerAdditionalInfo()) {
      this.addCustomerAdditionalInfoButton(buttons);
    } 
    // ListView mode buttons
    else if (this.contactService.contactPageMode === ComponentViewMode.LISTVIEW) {
      this.addListViewButtons(buttons);
    }
    
    return buttons;
  }

  private shouldShowCloseButton(): boolean {
    return (!!this.contactService.contactInformation || this.uiService.activeView === 'ContactPageRightPaneNav') &&
           this.isPopPageBtnEnabled || (!this.isPopPageBtnEnabled && !this.isSplitView());
  }

  private getEventParticipant(): any {
    let participant = this.eventsToolService.selectedEventOnEventsTool['eventPassesToSave']?.find(
      participant => participant.id === this.contactService.contactInformation.ID
    );
    return participant || this.eventsToolService.selectedEventOnEventsTool.participants.find(
      participant => participant.id === this.contactService.contactInformation.ID
    );
  }

  private shouldShowCustomerAdditionalInfo(): boolean {
    return this.uiService.contactDetailsSegment !== 'customer-assess' && 
           this.activityDataService.isCustomerAdditionalInformationEnabled &&
           this.contactService.contactPageMode !== ComponentViewMode.LISTVIEW;
  }

  private addCustomerAdditionalInfoButton(buttons: any[]): void {
    const logoforContactsTool = this.contactService.logoforContactsTool || 'assets/imgs/glance-pass.svg';
    if (this.contactService.labelforContactsTool) {
      buttons.push({
        id: "customer-additional-info",
        imgSrc: logoforContactsTool,
        name: this.contactService.labelforContactsTool,
        isDisabled: false,
        align: "right"
      });
    }
  }

  private createCloseButton(): any {
    return {
      id: "close",
      icon: "chevron-back-outline",
      isDisabled: false,
      align: "left"
    };
  }

  private applySpecialConditions(buttons: any[]): any[] {
    // If affiliation explorer is highlighted, show only close button
    if (this.contactHighLightedFromAffiliatedExplorer) {
      return [this.createCloseButton()];
    }
    
    // Check if we should show go-to contacts tool button
    this.isGoToContactBtnEnabled = this.uiService.contactDetailsSegment !== 'customer-assess' &&
                                  (this.contactService.contactPageMode === ComponentViewMode.PREVIEW || 
                                   this.accountService.accountPageMode === ComponentViewMode.PREVIEW) &&
                                  (this.uiService.isAccountsFromToolDrawer || this.uiService.isContactsFromToolDrawer) &&
                                  this.isPopPageBtnEnabled && 
                                  this.contactService.isEnableGoToContactsTool &&
                                  (this.dynamicFormService.isOpenedAffiliatedContactOnAccount || 
                                   this.dynamicFormService.isOpenedAffiliatedContactOnContact) &&
                                  !this.uiService.isForcedHideGoToToolBtn;
    
    // If go-to contacts tool is enabled OR we're from notification details, show close + open buttons
    if (this.isGoToContactBtnEnabled || (this.accessedFrom === 'NotificationDetails' && this.uiService.contactDetailsSegment !== 'customer-assess')) {
      return [
        this.createCloseButton(),
        {
          id: "goToContactsTool",
          imgSrc: 'assets/imgs/glance-open-in-new.svg',
          name: this.translate.instant('OPEN'),
          isDisabled: this._isDisabledGoToContactsToolBtn,
          align: "right"
        }
      ];
    }
    
    // If we're in assessment teamview, show only close-teamview button
    if (this.uiService.contactDetailsSegment === 'customer-assess-teamview') {
      return [{
        id: "close-teamview",
        icon: "chevron-back-outline",
        isDisabled: false,
        align: "left"
      }];
    }
    
    // If we're from territory management, show only goto territory button
    if (this.navParams.data?.from === PageName.TerritoryManagementDetailsComponent) {
      return [{
        id: "gotoTerritoryMgmtDetails",
        icon: "chevron-back-outline",
        isDisabled: false,
        align: "left"
      }];
    }
    
    // If we're from global search, show close button only if not split view
    if (this.navParams?.data?.link === 'globalSearch') {
      return this.isSplitView() ? [] : [this.createCloseButton()];
    }
    
    return buttons;
  }

  private isPassButtonDisabled(participant: EventParticipant) {
    return (isEmpty(participant?.eventPasses) &&
      (
        this.contactService.contactPageMode == ComponentViewMode.READONLY
        || this.device.isOffline
        || !this.eventsToolService.selectedEventOnEventsTool.passes.some(pass => pass.msevtmgt_noOfPassesLeft > 0)
      )
    )
      || isEmpty(this.eventsToolService.selectedEventOnEventsTool.passes);
  }

  private getPassButtonName(participant: EventParticipant) {
    if (participant && !isEmpty(participant.eventPasses)) {
      const passess = orderBy(participant.eventPasses.filter(pass => !pass['deleted']), 'msevtmgt_passName');
      return isEmpty(passess) ? this.translate.instant('PASS') : (passess[0].msevtmgt_passName + (passess.length > 1 ? (' +' + (passess.length - 1)) : ''));
    }
    return this.translate.instant('PASS');
  }

  private initOKPageTitleControls(): void {
    let buttons = [];
    if ((!!this.contactService.contactInformation || this.uiService.activeView == 'ContactPageRightPaneNav') &&
      this.isPopPageBtnEnabled || (!this.isPopPageBtnEnabled && !this.isSplitView())) {
      buttons.push({
        id: "close",
        icon: "chevron-back-outline",
        isDisabled: false,
        align: "left"
      });
    }
    const isAssessTeamview: boolean = this.uiService.contactDetailsSegment =='customer-assess-teamview';
    if(isAssessTeamview) {
      buttons = [{
        id: "close-teamview",
          icon: "chevron-back-outline",
          isDisabled: false,
          align: "left"
      }];
    }
    this.okPageTitleControls = buttons
    this.okGlanceBackButton = buttons.find(button => button.align === 'left');
    const okContact = this.contactService.selectedOKContact?.value;
    this.okGlanceViewData = okContact ? oneKeyGlanceViewData(this.contactService.getFullName(okContact)) : undefined;
  }

  public async onPageTitleControlClick(id: string) {
    switch (id) {
      case 'close':
        if (this.isFromChat) {
          this.modalCtrl.dismiss();
        } else if (this.isPopPageBtnEnabled) {
          this.poppage();
        } else if (!this.isPopPageBtnEnabled && !this.isSplitView()) {
          this.closepage();
        } else if (this.accessedFrom === 'NotificationDetails') {
            this.navService.popChildNavPageWithPageTracking();
        }
        break;
      case 'close-teamview':
        this.uiService.contactDetailsSegment = 'customer-assess';
        this.initOKPageTitleControls();
        this.initPageTitleControls();
        break;
      case 'pluse-icon':
        this.handlePlusButton();
        break;
      case 'customer-additional-info':
        this.handleNavigationForBaseURL();
        break;
      case 'affiliation-explorer':
        this.handleAffiliationExplorer();
        break;
      case 'goToContactsTool':
        this.handleGoToContactsTool();
        break;
      case 'eventNote':
        // this.handleEventNoteClick();
        break;
        case 'gotoTerritoryMgmtDetails':
        this.handleGoToTerritoryMgmtDetails();
        break;
      case 'qrcode':
        await this._handleGenerateQrCode();
        break;
      default:
        break;
    }
  }

  private async _handleGenerateQrCode() {
    const emailVal = this.authenticationOfflineService.user.mail ? this.authenticationOfflineService.user.mail.split('@') : [];
    const contact = this.contactService.contactInformation;
    const contactEtms = contact.indskr_externalid;
    if (!contactEtms) {
      this.notificationService.notify(this.translate.instant('CONTACT_NO_HCPCODE'), 'DynamicFormComponent', "top", ToastStyle.INFO, 3000);
      return;
    }
    if (isEmpty(contact.accountRelationships)) {
      this.notificationService.notify(this.translate.instant('CONTACT_NO_AFFILIATIONS'), 'DynamicFormComponent', "top", ToastStyle.INFO, 3000);
      return;
    }
    const account = this.accountService.getAccountById(contact.accountRelationships[0].accountId);
    if (!account || !account.extendedDetails || !account.extendedDetails['externalId']) {
      this.notificationService.notify(this.translate.instant('ACCOUNT_ETMS_ERR_NOTIFY', { accountName: (account && account.accountName) ? account.accountName : "" }), 'DynamicFormComponent', "top", ToastStyle.INFO, 3000);
      return;
    }
    this.uiService.displayLoader();
    const payload = {
      userid: !isEmpty(emailVal) ? emailVal[0] : null,
      businessCode: contactEtms,
      type: this.buLine,
      hcoCode: account.extendedDetails['externalId']
    };
    let qrResponse: any;
    try {
      qrResponse = await this.mdmService.getHcpQrCode(payload);
    } finally {
      this.uiService.dismissLoader();
    }
    if (qrResponse?.status == 1000 && qrResponse?.data.qrcodeUrl) {
      const popover = await this.popoverCtrl.create({
        component: HopQRCodeModal,
        componentProps: { qrCodeData: qrResponse?.data.qrcodeUrl },
        cssClass: "hop-qr-code-modal",
        backdropDismiss: true
      });
      popover.present();
    } else if (qrResponse?.status == 2004 && qrResponse?.message) {
      this.notificationService.notify(qrResponse?.message, 'DynamicFormComponent', "top", ToastStyle.INFO, 3000);
    }
  }

  private async handlePassButton(event: Event) {
    const selectedPassIds = [];
    const eventParticipant = this.eventsToolService.selectedEventOnEventsTool.participants?.find(participant => participant.id === this.contactInfo.ID);
    let participant = this.eventsToolService.selectedEventOnEventsTool['eventPassesToSave']?.find(participant => participant.id === this.contactInfo.ID);
    participant = participant ? participant : eventParticipant;
    const data: SelectListData[] = orderBy(this.eventsToolService.selectedEventOnEventsTool.passes, obj => obj.msevtmgt_passName).map(pass => {
      const isPassSelected: boolean = participant?.eventPasses ? participant.eventPasses.some(eventPass => eventPass.msevtmgt_passId == pass.msevtmgt_passId && !eventPass.deleted) : false;
      if (isPassSelected) selectedPassIds.push(pass.msevtmgt_passId);
      if (!(!isPassSelected && pass['temp_msevtmgt_noOfPassesLeft'] <= 0)) {
        return {
          id: pass.msevtmgt_passId,
          title: pass.msevtmgt_passName,
          isSelected: isPassSelected
        }
      }
    })
    const dropdownListDetail: IndDropdownListDetailModel = {
      id: 'pass-dropdown',
      data: remove(data, undefined),
      isReadOnly: this.device.isOffline
    };
    const dropdown = await this.popoverCtrl.create({
      component: IndDropdownListComponent,
      componentProps: { viewData: dropdownListDetail },
      cssClass: 'dropdown-list-view',
      event: event,
    });
    await dropdown.present();
    await dropdown.onDidDismiss().then(async (obj: any) => {
      if(this.device.isOffline) return;
      if (obj?.data && obj.data.isDone) {
        if (obj.data.selectedItems.length == selectedPassIds.length && obj.data.selectedItems.every(item => selectedPassIds.includes(item.id))) return;
        this.prepareEventAttendeePassPayload(obj.data.selectedItems.map(item => item.id), eventParticipant);
        this._initGlanceCard(true);
        this.events.publish('updateContactListIsDirty');
      }
    })
  }

  private prepareEventAttendeePassPayload(selectedPassIds: string[], eventParticipant) {
    const eventPassesToRemove = [];
    const contactID = this.contactInfo?.ID ? this.contactInfo.ID : eventParticipant?.id;
    if (eventParticipant?.eventPasses) {
      this.removeSavedEventPasses(selectedPassIds, eventPassesToRemove, eventParticipant);
    }
    this.removeUnSavedEventPasses(selectedPassIds, contactID, eventParticipant);
    const eventPassesToSave = [];
    selectedPassIds
      .forEach(passId => {
        let existingEPassIndex;
        if(eventParticipant && eventParticipant.eventPasses) existingEPassIndex = eventParticipant?.eventPasses.findIndex(pass => pass.msevtmgt_passId === passId);
        const index = this.eventsToolService.selectedEventOnEventsTool.passes.findIndex(pass => pass.msevtmgt_passId == passId);
        if (index >= 0) {
          this.eventsToolService.selectedEventOnEventsTool.passes[index]['temp_msevtmgt_noOfPassesLeft'] -= 1;
        }
        eventPassesToSave.push({
          msevtmgt_attendeepassid: existingEPassIndex >= 0 ? eventParticipant?.eventPasses[existingEPassIndex].msevtmgt_attendeepassId : Guid.create().toString(),
          msevtmgt_passName: this.eventsToolService.selectedEventOnEventsTool.passes[index].msevtmgt_passName,
          passId: passId,
          msevtmgt_passId: passId
        })
      });
    const payload = [...eventPassesToRemove, ...eventPassesToSave];
    if (isEmpty(this.eventsToolService.selectedEventOnEventsTool['eventPassesToSave'])) this.eventsToolService.selectedEventOnEventsTool['eventPassesToSave'] = [];
    const eventPassToSaveInx = this.eventsToolService.selectedEventOnEventsTool['eventPassesToSave'].findIndex(passesToSave => passesToSave.id == contactID);
    if (eventPassToSaveInx == -1) {
      this.eventsToolService.selectedEventOnEventsTool['eventPassesToSave'].push({
        id: contactID,
        eventPasses: payload
      });
    } else {
      this.eventsToolService.selectedEventOnEventsTool['eventPassesToSave'][eventPassToSaveInx].eventPasses = payload;
    }
  }

  private removeUnSavedEventPasses(selectedPassIds: string[], contactId, eventParticipant) {
    if (this.eventsToolService.selectedEventOnEventsTool['eventPassesToSave']) {
      const eventPassesToSave = this.eventsToolService.selectedEventOnEventsTool['eventPassesToSave'].find(eventPass => eventPass.id === contactId);
      if (eventPassesToSave) {
        eventPassesToSave.eventPasses.filter(eventPass => !selectedPassIds.includes(eventPass.msevtmgt_passId)).forEach(item => {
          const existingEPass = eventParticipant?.eventPasses.find(pass => pass.msevtmgt_passId === item.msevtmgt_passId);
          if (!existingEPass) {
            const index = this.eventsToolService.selectedEventOnEventsTool.passes.findIndex(pass => pass.msevtmgt_passId == item.msevtmgt_passId);
            if (index >= 0)
              this.eventsToolService.selectedEventOnEventsTool.passes[index]['temp_msevtmgt_noOfPassesLeft'] += 1;
          }
        })
      }
    }
  }

  private removeSavedEventPasses(selectedPassIds: string[], eventPassesToRemove: any[], eventParticipant) {
    eventParticipant.eventPasses
      .filter(eventPass => !selectedPassIds.includes(eventPass.msevtmgt_passId))
      .forEach(eventPass => {
        const index = this.eventsToolService.selectedEventOnEventsTool.passes.findIndex(pass => pass.msevtmgt_passId == eventPass.msevtmgt_passId);
        if (index >= 0) {
          this.eventsToolService.selectedEventOnEventsTool.passes[index]['temp_msevtmgt_noOfPassesLeft'] += 1;
          eventPassesToRemove.push({
            msevtmgt_passId: eventPass.msevtmgt_passId,
            msevtmgt_attendeepassid: eventPass.msevtmgt_attendeepassId,
            msevtmgt_passName: this.eventsToolService.selectedEventOnEventsTool.passes[index].msevtmgt_passName,
            eventRegId: eventParticipant.registrationId,
            deleted: true
          });
        }
      });
  }

  onScroll(ev) {
    this.scrollBehaviorSubject.next(ev);
  }

  onFooterButtonClicked(buttonId: string) {
    if (this.ccCapture) this.ccCapture.footerHandler(buttonId);
  }

  handleGoToContactsTool() {
    this.contactService.isClickedGoToContactsTool = true;
    this.uiService.isContactsFromToolDrawer = true;
    this.contactService.isInGlobalSearch = false;
    if (!this.contactService.isNotInMyContactList) {
      const contactInfo = this.contactService.contactInformation;
      this.uiService.isContactsFromToolDrawer = true;
      this.navService.setRootWithTracking(PageName.ContactPageComponent, PageName.ContactPageComponent, {__source: 'menu', from: 'ContactTool', openedToolFromContactDetails: true, contactInformation: contactInfo}, PageName.ContactPageComponent).then(()=> {
        this.navService.setChildNavRightPaneView(true);
      });
    } else if (this.contactService.errorMessageOpenContactDetails) {
      this.contactService.isClickedGoToContactsTool = false;
      this.notificationService.notify(this.contactService.errorMessageOpenContactDetails, 'Contact Details', 'top', ToastStyle.INFO);
      this._isDisabledGoToContactsToolBtn = true;
      this.initPageTitleControls();
    }
  }

  handleGoToTerritoryMgmtDetails() {
    this.navService.popChildNavPageWithPageTracking().then(() => {
      this.callbackEvent();
    });
    this.navService.setChildNavRightPaneView(true);
  }

  private async openEventParticipantDetailsForm(event: EventActivity) {
    const eventParticipant = this.eventsToolService.getEventParticipantByContactId(
      event.participants,
      this.contactService.contactInformation.ID,
    );
    const viewData: Record<string, any> = {
      eventParticipant,
      currentEvent: event,
    };
    if (!eventParticipant) {
      viewData.contact = this.contactService.contactInformation;
    }
    await this.navService.pushChildNavPageWithPageTracking(PageName.EventParticipantComponent, PageName.ContactDetailsComponent, PageName.EventParticipantComponent, viewData)
  }

  /**
   * A contact outside the rep's position has no local record, so the linked-entity mapping worker
   * never runs for it and addressesList stays empty — getPrimaryAddress returns nothing even though
   * the address was fetched. Read it from the same raw subgrid data the Info tab renders.
   */
  private _getGlobalSearchLocationText(): string {
    const rows = this.contactService.contactInformation?.raw?.['globalSearchedDataLinkEntities']?.['indskr_indskr_customeraddress_v2'];
    if (!Array.isArray(rows) || !rows.length) return '';
    const primary = rows.find(r => r?.['indskr_indskr_customeraddress_v2.indskr_isprimary']) ?? rows[0];
    return primary?.['indskr_address.indskr_composite']
      || primary?.['indskr_indskr_customeraddress_v2.indskr_address@OData.Community.Display.V1.FormattedValue']
      || '';
  }

  private async _initGlanceCard(updateButtonsOnly: boolean = false) {
    if (this.authenticationOfflineService.hasFeatureAction(FeatureActionsMap.CUSTOMER360UI, true)) {
      let glanceCardButtons = [];
      const isGlobalSearch: boolean = this.navParams?.data && this.navParams.data?.link == 'globalSearch' || this.contactService.isContactInGlobalSearch(this.contactService.contactInformation) || false;
      const isReadOnlyView: boolean = this.isFromChat || this.isOpenedUnmappedAffiliationData || isGlobalSearch;
      // The activity tiles come from ContactQuickActionsService now; what is built here is
      // the tool tail that follows the divider.
      if (this.contactService.isAffiliationEnabled && !isReadOnlyView) {
        glanceCardButtons.push({
          id: "affiliation-explorer",
          imgSrc: 'assets/imgs/glance-affiliation-explorer.svg',
          name: this.translate.instant('AFFILIATION_EXPLORER'),
          isDisabled: !this.contactService.hasAffiliationsForContact(),
          align: "right"
        });
      }
      if (this._canGenerateQrCode()) {
        glanceCardButtons.push({
          id: "qrcode",
          imgSrc: 'assets/imgs/glance-qr-code.svg',
          name: this.translate.instant('QR_CODE'),
          // The code is minted by MDM on request; there is nothing to show without a network.
          isDisabled: this.device.isOffline,
          align: "right"
        });
      }
      if (this.isEventPassParticipantAssociationEnabled) {
        const participant = this.getEventParticipant();
        glanceCardButtons.push({
          id: 'addPass',
          imgSrc: 'assets/imgs/glance-pass.svg',
          name: this.getPassButtonName(participant),
          isDisabled: this.isPassButtonDisabled(participant),
          align: 'right'
        });
      }
      if (!isGlobalSearch) {
        glanceCardButtons.push({
          id: "personalize-quick-glance",
          imgSrc: 'assets/imgs/glance-personalize-settings.svg',
          name: 'Personalize Quick Glance',
          isDisabled: this.isFromChat,
          align: "right"
        });
      }
      this._refreshQuickActions();
      this.glanceCardTools = glanceCardButtons.filter(button => !this._isContactActivityId(button.id));
      const tools = [...this.glanceCardTools, ...this.titleBarTools];
      if (updateButtonsOnly && this.contactGlanceViewData) {
        // Spread to new reference so GlanceCardComponent (OnPush) detects the change.
        this.contactGlanceViewData = { ...this.contactGlanceViewData, buttons: tools };
        this.changeDetectorRef.detectChanges();
        return;
      }
      const values = await this.contactService._getQuickGlanceValues();

      if(!this.device.isOffline){
        this.contactService.getEntityImageStringForContact(this.contactService.contactInformation).then((entityImageString => {
          if(entityImageString){ 
            this.contactService.contactInformation.entityImage = entityImageString;
            if(this.contactGlanceViewData){
              this.contactGlanceViewData.avatarURL = this.contactService.contactInformation.entityImage
            }
          }
        }));
      }

      const sequenceName = this.contactService.getFullNameForContactDisplaySequence(this.contactService.contactInformation);

      this.contactGlanceViewData = {
        name: sequenceName,
        locationText: this.contactService.contactInformation.getPrimaryAddress || this._getGlobalSearchLocationText(),
        avatarURL: this.contactService.contactInformation.entityImage,
        thirdText: (values && values.length && values[0]) ? values[0].value : '',
        fourthText: (values && values.length && values[1]) ? values[1].value : '',
        fifthText: (values && values.length && values[2]) ? values[2].value : '',
        sixthText: (values && values.length && values[3]) ? values[3].value : '',
        thirdTextLabel: (values && values.length && values[0]) ? values[0].label : '',
        fourthTextLabel: (values && values.length && values[1]) ? values[1].label : '',
        fifthTextLabel: (values && values.length && values[2]) ? values[2].label : '',
        sixthTextLabel: (values && values.length && values[3]) ? values[3].label : '',
        buttons: tools,
        enableExpand: false,
        isExpanded: true,
        lastInteraction: this._lastInteractionGlanceRow(),
      };
      // PouchDB callbacks may run outside Angular's zone; force a CD pass so
      // GlanceCardComponent (OnPush) receives the new viewData reference.
      this.changeDetectorRef.detectChanges();
    }
  }

  // Out-of-position contacts are never in the interactions response, so "none" would be a false claim.
  private _lastInteractionGlanceRow(): GlanceCardViewDataModel['lastInteraction'] {
    const contact = this.contactService.contactInformation;
    if (!contact?.ID || this._isGlanceReadOnly()) return undefined;
    const interaction = this.contactService.getContactInteractionByDays(contact.ID);
    if (!interaction?.interactionDate) {
      return { label: '', detail: this.translate.instant('GLANCE_NO_INTERACTION_IN_DAYS', { days: this.contactService.contactNotInteractedDays }) };
    }
    const days = differenceInCalendarDays(new Date(), interaction.interactionDate);
    const relative = days <= 0 ? this.translate.instant('TODAY')
      : days === 1 ? this.translate.instant('YESTERDAY')
      : this.translate.instant('GLANCE_LAST_INTERACTION_DAYS_AGO', { days });
    const date = this.datePipe.transform(interaction.interactionDate, this.dateTimeFormatsService.date, undefined, this.translate.currentLang);
    return { label: interaction.interactionType || '', detail: `${relative} · ${date}` };
  }

  /** A contact opened from chat, from an unmapped affiliation or from global search is read only. */
  private _isGlanceReadOnly(): boolean {
    const isGlobalSearch = (this.navParams?.data && this.navParams.data?.link == 'globalSearch')
      || this.contactService.isContactInGlobalSearch(this.contactService.contactInformation) || false;
    return this.isFromChat || this.isOpenedUnmappedAffiliationData || isGlobalSearch
      || !this.contactService.getContactByID(this.contactService.contactInformation?.ID);
  }

  /** The glance buttons that the registry now owns; whatever is left is a tool. */
  private _isContactActivityId(id: string): boolean {
    return this.quickActions.types().some(type => type.id === id);
  }

  /** The strip, rebuilt: the cap changed, a pin moved, or the card is being drawn. */
  private _refreshQuickActions(): void {
    const types = this._isGlanceReadOnly() || !this.contactService.contactInformation
      ? [] : this.quickActions.types();
    ({ tiles: this.contactQuickActions, hasOverflow: this.hasQuickActionOverflow } = this.quickActionStrip.layout(types, 'contact'));
    this.changeDetectorRef.detectChanges();
  }

  public async openQuickActionOverflow(event: Event): Promise<void> {
    await this.quickActionStrip.openOverflow(event, this.quickActions.types(), 'contact',
      () => this._refreshQuickActions());
    // onDidDismiss escapes the zone (OMNI-60723); this component is OnPush.
    this.changeDetectorRef.detectChanges();
  }

  public async onQuickGlanceControlClick(data){
    if(data.id){
      if (await this.quickActionStrip.runById(this.quickActions.types(), data.id, data.event)) {
        this.changeDetectorRef.detectChanges();
        return;
      }
      switch(data.id) {
        case 'affiliation-explorer':
          this.handleAffiliationExplorer();
          break;
        case 'personalize-quick-glance':
          this._openPersonalizeQuickGlanceView();
          break;
        case 'qrcode':
          await this._handleGenerateQrCode();
          break;
        case 'addPass':
          await this.handlePassButton(data.event);
          break;
        case 'open-location':
          this._handleOpenLocation();
          break;
        case 'goToContactsTool':
        case 'customer-additional-info':
          await this.onPageTitleControlClick(data.id);
          break;
        default:
          break;
      }
    }
  }

  private async _openPersonalizeQuickGlanceView(){
    let options = await this._getQuickGlanceOptions();
    let personalizeQuickGlanceView:PersonalizeQuickGlanceViewDataModel = {
      id: 'personalizeQuickGlance',
      pageSectionHeader: {
        id:'personalizeQuickGlanceTitleSectionHeader',
        title: this.translate.instant('PERSONALIZE_QUICK_GLANCE'),
        controls: []
      },
      infoText: this.translate.instant('SELECT_ANY_4_SECTION_TO_VIEW_ON_CARD'),
      data: options,
      callbackEvent:async (id:string, event:any, dataRef:any)=> await this._handlePersonalizeQuickGlanceSave(id,event,dataRef),
    }
    const modal = await this.modalCtrl.create({
      component: await getComponent(PageName.PersonalizedQuickGlanceViewComponent).resolve(),
      cssClass: 'filter-menu-right-modal',
      backdropDismiss: true,
      componentProps: { viewData: personalizeQuickGlanceView },
    });
    await modal.present();
  }

  private async _getQuickGlanceOptions(){
    let result:Array<{id:string,title:string,isChecked:boolean}> = [];
    let contactForm: DynamicForm = await this.dynamicFormService.getFormDefinitionForEntity("contact", FormType.DISPLAYFORM);
    const alreadySavedOptions = await this.contactService.getQuickGlanceOptions();
    const langCode = (!contactForm) ? DEFAULT_FORM_LANGUAGE_CODE : this.localizationService.selectedLanguage.localeID;
    if (!contactForm) {
      contactForm = new DynamicForm(DEFAULT_CONTACT_DISPLAY_FORM['value'][0]);
    }
    contactForm.metadata.forEach((tab) => {
      if (tab && tab.controls && tab.controls.length > 0) {
        tab.controls.forEach(control => {
          if (this.dynamicFormService.checkIfControlShouldNotBeVisible(control) || control.forceHide || control.dataType == ControlDataType.StateType || control.dataType == ControlDataType.StatusType || !control.dataType || !control.isVisible || EXCLUDED_CONTACT_GLANCE_CARD_ATTRIBUTES.some(a=> a == control.attributeName)) {
          }else {
            let displayTitle:string = '';
            const dt = control.displayNames.find(value => value.languagecode == langCode);
            if (dt) {
              displayTitle = dt.languagecode == DEFAULT_FORM_LANGUAGE_CODE ? this.translate.instant(dt.description) : dt.description;
            } else {
              let en = control.displayNames.find(value => value.languagecode == "1033"); // default to english if no translation for the specific language;
              if (en) {
                displayTitle = en.description
              } else {
                //recheck the default form language code in the case of custom fields
                const defalutLang = control.displayNames.find(value => value.languagecode == '0000');
                if(defalutLang && defalutLang.description) {
                  displayTitle = this.translate.instant(defalutLang.description);
                } else {
                  displayTitle = '';
                }
              }
            }
            result.push({
              id: control.attributeName,
              title: displayTitle,
              isChecked: alreadySavedOptions.some(a=> a == control.attributeName),
            })
          }
        });
      }
    });
    return result;
  }

  private async _handlePersonalizeQuickGlanceSave(id,event,dataRef){
    if(dataRef && Array.isArray(dataRef)){
      const selectedAttributes = dataRef.filter(a=> a.isChecked)?.map(b=> b.id);
      await this.contactService.saveQuickGlanceOptions(selectedAttributes);
      await this._initGlanceCard();
    }
  }

  private _handleOpenLocation(){
    if(this.contactService.contactInformation && this.contactService.contactInformation.getPrimaryAddress){
      const location = this.contactService.contactInformation.getPrimaryAddress;
      
    }
  }

  private _canGenerateQrCode(): boolean {
    return this.showQrCodeBtn
      && (!this.contactService.isInGlobalSearch || this.contactService.isContactInGlobalSearch(this.contactService.contactInformation))
      && this.authenticationOfflineService.hasFeatureAction(FeatureActionsMap.GENERATE_QR_CODE_LD, true);
  }

  private addListViewButtons(buttons: any[]): void {
    // Add customer additional info button if enabled
    if (this.activityDataService.isCustomerAdditionalInformationEnabled) {
      this.addCustomerAdditionalInfoButton(buttons);
    }
    
    // Only without the glance card, which is where the button lives when there is one.
    if (this._canGenerateQrCode() && !this.authenticationOfflineService.hasFeatureAction(FeatureActionsMap.CUSTOMER360UI, true)) {
      buttons.push({
        id: "qrcode",
        imgSrc: 'assets/imgs/qr_code_white.svg',
        name: this.translate.instant('QR_CODE'),
        align: "right"
      });
    }
    
    // Add affiliation explorer button if affiliation is enabled and not customer360UI
    if (this.contactService.isAffiliationEnabled && 
        !this.authenticationOfflineService.hasFeatureAction(FeatureActionsMap.CUSTOMER360UI, true)) {
      buttons.push({
        id: "affiliation-explorer",
        imgSrc: 'assets/imgs/affiliation-explorer.svg',
        name: this.translate.instant('AFFILIATION_EXPLORER'),
        isDisabled: !this.contactService.hasAffiliationsForContact(),
        align: "right"
      });
    }
    
    // Add create button (plus icon) if conditions are met
    const hideNewActivityCreation = (this.featureActionService.isShortCallLauncherEnabledInMobileDevice && 
                                   this.authenticationOfflineService.hasFeatureAction(FeatureActionsMap.SHOR_CALL_LAUNCHER_DISABLE_APPOINTMENT_IN_NEW_ACTIVITY)) ? 
      !(this.authenticationOfflineService.hasFeatureAction(FeatureActionsMap.ALLOCATION_ORDER_ACTIVITY) ||
        this.authenticationOfflineService.hasFeatureAction(FeatureActionsMap.MESSAGE_ACTIVITY) ||
        this.authenticationOfflineService.hasFeatureAction(FeatureActionsMap.CASE_INTAKE) ||
        this.authenticationOfflineService.hasFeatureAction(FeatureActionsMap.XPERIENCES) ||
        this.authenticationOfflineService.hasFeatureAction(FeatureActionsMap.PHONECALL_ACTIVITY) ||
        this.authenticationOfflineService.hasFeatureAction(FeatureActionsMap.PROCEDURE_LOG) ||
        this.authenticationOfflineService.hasFeatureAction(FeatureActionsMap.OPPORTUNITY_MANAGEMENT)) : false;
    
    if ((!this.contactService.isInGlobalSearch || !this.contactService.isContactInGlobalSearch(this.contactService.contactInformation)) && 
        !hideNewActivityCreation) {
      buttons.push({
        id: "pluse-icon",
        imgSrc: 'assets/imgs/ios_add_3x.svg',
        name: this.translate.instant('CREATE'),
        isDisabled: this.contactService.isOneKeySearching,
        align: "right"
      });
    }
  }

  private async initContactJourneyData() {
    if (!this.hasContactJourney || this.isContactInGlobalSearch || this.isFromConsentToolDrawer() || this.contactService.isOneKeySearching || this.isFromOpenChat()) {
      return;
    }
    this.contactInfo = this.contactService.contactInformation;
    const contactId = this.contactInfo?.ID;

    // Runs again for every contact the detail pane switches to, on the same
    // component instance: clear the previous contact's figures and drop its
    // rxData$ subscription, or a later emission writes that contact's rows
    // back into these inputs.
    this.journeyDataReset$.next();
    this.rawContactSuggestionData = [];
    this.rawContactRxSalesData = [];
    this.rawContactRxSalesDataRealTimeFetched = [];

    // Fetched unconditionally regardless of PDRP opt-out / restrict-access —
    // adoption-ladder-journey.ts is what gates display for a restricted
    // contact, so the figures stay available there for territory-level
    // rollups rather than never being fetched at all.
    if (contactId) {
      // check local db data
      this.rxSalesDataService.rxData$.pipe(takeUntil(this.journeyDataReset$), takeUntil(this.ngDestroy$)).subscribe(data => {
        if (Array.isArray(data) && data.length > 0) {
          const filteredData = data.filter(item => item?.contact?.ID === contactId);
          this.rawContactRxSalesData = filteredData;
        }
      });

      let tasks = [];
      tasks.push(this.adoptionLadderJourneyService.fetchContactJourneySuggestionData(contactId));
      tasks.push(this.adoptionLadderJourneyService.fetchContactRxSalesData(contactId));

      const results = await Promise.all(tasks);
      // The pane can have moved on to another contact while these were in
      // flight, and the slower of the two contacts' fetches resolves last:
      // assigning here regardless is how one contact's figures end up under
      // another's name (OMNI-62226).
      if (this.contactService.contactInformation?.ID !== contactId) return;
      if (results && results.length > 0) {
        if (results[0]) {
          this.rawContactSuggestionData = results[0];
        }
        if (results[1]) {
          this.rawContactRxSalesDataRealTimeFetched = results[1];
        }
      }
    }
  }
}
